/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Cn_Android_Paywall_7_Day_TitleInputs */

const en_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus Benefits 
End in <span style="#2AFD00">${i?.number}</span> Days.`)
};

const ar_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مزايا Plus
الأيام المتبقية حتى انتهائها: <span style="#2AFD00">${i?.number}</span>`)
};

const de_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine Plus-Vorteile
enden in <span style="#2AFD00">${i?.number}</span> Tagen`)
};

const es_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tus ventajas de Plus
terminan en <span style="#2AFD00">${i?.number}</span> días`)
};

const fr_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tes avantages Plus
prennent fin dans <span style="#2AFD00">${i?.number}</span> jours`)
};

const it_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I tuoi vantaggi Plus
terminano tra <span style="#2AFD00">${i?.number}</span> giorni`)
};

const ja_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plusの特典は
あと<span style="#2AFD00">${i?.number}</span>日で終了します`)
};

const ko_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 혜택이
<span style="#2AFD00">${i?.number}</span>일 후 종료돼요`)
};

const pt_br_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benefícios Plus
Dias até o término: <span style="#2AFD00">${i?.number}</span>`)
};

const ru_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Преимущества Plus
Истекают через <span style="#2AFD00">${i?.number}</span> дн.`)
};

const th_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สิทธิประโยชน์ Plus
จะสิ้นสุดในอีก <span style="#2AFD00">${i?.number}</span> วัน`)
};

const tr_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus avantajların
<span style="#2AFD00">${i?.number}</span> gün sonra sona eriyor`)
};

const zh_cn_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 会员权益
 <span style="#2AFD00">${i?.number}</span> 天后失效`)
};

const zh_tw_cn_android_paywall_7_day_title = /** @type {(inputs: Cn_Android_Paywall_7_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 權益將於
<span style="#2AFD00">${i?.number}</span> 天後到期`)
};

/**
* | output |
* | --- |
* | "Plus Benefits End in <span style=\"#2AFD00\">{number}</span> Days." |
*
* @param {Cn_Android_Paywall_7_Day_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cn_android_paywall_7_day_title = /** @type {((inputs: Cn_Android_Paywall_7_Day_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cn_Android_Paywall_7_Day_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cn_android_paywall_7_day_title(inputs)
	if (locale === "ar") return ar_cn_android_paywall_7_day_title(inputs)
	if (locale === "de") return de_cn_android_paywall_7_day_title(inputs)
	if (locale === "es") return es_cn_android_paywall_7_day_title(inputs)
	if (locale === "fr") return fr_cn_android_paywall_7_day_title(inputs)
	if (locale === "it") return it_cn_android_paywall_7_day_title(inputs)
	if (locale === "ja") return ja_cn_android_paywall_7_day_title(inputs)
	if (locale === "ko") return ko_cn_android_paywall_7_day_title(inputs)
	if (locale === "pt_br") return pt_br_cn_android_paywall_7_day_title(inputs)
	if (locale === "ru") return ru_cn_android_paywall_7_day_title(inputs)
	if (locale === "th") return th_cn_android_paywall_7_day_title(inputs)
	if (locale === "tr") return tr_cn_android_paywall_7_day_title(inputs)
	if (locale === "zh_cn") return zh_cn_cn_android_paywall_7_day_title(inputs)
	return zh_tw_cn_android_paywall_7_day_title(inputs)
});